import React, {useContext, useEffect, useState} from 'react'
import ResourceModal from "./ResourceModal"
import FormDateTimePicker from "../lib/FormDateTimePicker"
import {ResourceContext} from "../contexts/ResourceContext"

const InstrumentOfflineModal = ({resource, show, onClose}) => {
  const { reloadResources } = useContext(ResourceContext)
  const [formState, setFormState] = useState({})
  const [errors, setErrors] = useState({})

  useEffect(
    () => {
      setFormState({takeOfflineAt: new Date().toJSON()})
      setErrors({})
    },
    [resource]
  )

  const handleInputChange = (ev) => {
    const name = ev.target.name
    let value = ev.target.value
    setFormState({...formState, [name]: value})
  }

  const save = () => {
    if (!formState.takeOfflineAt || formState.takeOfflineAt === '') {
      setErrors({takeOfflineAt: 'must be given'})
      return
    }
    let state = Object.assign({}, formState)
    resource.assignAttributes({...state})
    return resource.save().then(() => {
      reloadResources("Instrument taken offline")
      onClose()
    }).catch(_err => {
      setErrors({takeOfflineAt: 'is invalid'})
    })
  }

  if (!resource) {
    return null
  }

  return (
    <ResourceModal show={show} onClose={onClose} onSubmit={save} resource={resource} title="Take instrument offline" submitLabel="Create">
      {resource.fullName}
      <hr/>
      {resource.group &&
      <p><strong>Create offline calibration for the group and all its child instruments</strong></p>}
      {!resource.group &&
      <p><strong>Create offline calibration for the instrument</strong></p>}
      <FormDateTimePicker name="takeOfflineAt"
                          label="Offline from time"
                          horizontal
                          value={formState.takeOfflineAt}
                          error={errors.takeOfflineAt}
                          onChange={handleInputChange}/>
    </ResourceModal>
  )
}

export default InstrumentOfflineModal
